// Default Seed Values (Labelmap values)
export const POSITIVE_SEED_LABEL = 254;
export const NEGATIVE_SEED_LABEL = 255;

// Default Parameters for Seed Criteria
export const DEFAULT_NEIGHBORHOOD_RADIUS = 1;
export const DEFAULT_POSITIVE_STD_DEV_MULTIPLIER = 1.8;
export const DEFAULT_NEGATIVE_STD_DEV_MULTIPLIER = 3.2;
export const DEFAULT_NEGATIVE_SEED_MARGIN = 30;
export const DEFAULT_NEGATIVE_SEEDS_COUNT = 70;
export const MAX_NEGATIVE_SEED_ATTEMPTS_MULTIPLIER = 50;
